export default __webpack_public_path__ + "static/media/Tourism.729d85ae.svg";